import { useTranslator } from '@jutro/locale';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import {
    fnolCommonMessages,
    FNOLLossLocation,
} from 'gw-capability-fnol-common-react';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import wizardConfig from '../../../config/fnol-pa-wizard-config.json5';
import './CollisionDetailsPage.messages';
import metadata from './CollisionDetailsPage.metadata.json5';

function FNOLPACollisionDetailsPage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        changeNextSteps,
        currentStepIndex,
        history: {
            location: { state: claimDetails = {} },
        },
    } = props;
    const { steps: wizardSteps } = wizardConfig;
    const { capabilitiesConfig } = appConfig;
    const translator = useTranslator();
    const [showPropertyIncident, updateShowPropertyIncident] = useState(false);
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation,
    } = useValidation('CollisionDetailsPage');

    const onHandlePropertyDamageChange = (value, path) => {
        updateShowPropertyIncident(value);
        _.set(claimVM, path, value);
        updateWizardData(claimVM);
    };

    useEffect(() => {
        let nextSteps = wizardSteps.slice(
            currentStepIndex + 1,
            wizardSteps.length
        );
        if (
            !isCapabilityEnabled({
                capabilitiesConfig,
                capabilityName: 'vendor',
            })
        ) {
            nextSteps = nextSteps.filter(
                step => step.path !== '/type-of-repair'
            );
        }
        changeNextSteps(nextSteps);
        // Call once when page is mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: true,
        },
        wasAnyPropertyDamaged: {
            value: showPropertyIncident,
        },

        describePropertyDamage: {
            visible: showPropertyIncident,
        },
        lossLocationComponent: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData,
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onHandlePropertyDamageChange: onHandlePropertyDamageChange,
            onValidate: onValidate,
        },
        resolveComponentMap: {
            losslocationcomponent: FNOLLossLocation,
        },
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                claimVM,
                id,
                path,
                overrideProps
            );
        },
        [claimVM, overrideProps]
    );

    const isClaimStatus = useCallback(() => {
        const { claimStatus } = claimDetails;
        return !_.isEmpty(claimStatus);
    }, [claimDetails]);

    useEffect(() => {
        registerInitialComponentValidation(isClaimStatus);
    }, [registerInitialComponentValidation, isClaimStatus]);

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
                resolveValue={readValue}
            />
        </WizardPage>
    );
}

FNOLPACollisionDetailsPage.propTypes = wizardProps;
FNOLPACollisionDetailsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(FNOLPACollisionDetailsPage);
